import { CallApi } from '../api'
import {
  startGetListProducts,
  successGetListProducts,
  failRequestApiFromProductSlice,
} from '../../components/resources/UpdateRequestModal/Products/slice'

export const getProducts = (requestId: string): ((dispatch: any) => Promise<void>) => {
  return async (dispatch) => {
    dispatch(startGetListProducts())
    try {
      const res = await CallApi({
        endpoint: `product/${requestId}`,
        method: 'GET',
      })
      dispatch(successGetListProducts(res))
    } catch (err) {
      dispatch(failRequestApiFromProductSlice(err))
    }
  }
}

export const deleteProduct = async (id: string, callback: (isSuccess: boolean, message?: string) => void): Promise<void> => {
  try {
    await CallApi({
      endpoint: `product/${id}`,
      method: 'DELETE',
    })
    callback(true)
  } catch (err) {
    callback(false, err.message)
  }
}

export const createProduct = async (data: unknown, callback: (isSuccess: boolean, message?: string) => void): Promise<void> => {
  try {
    await CallApi({
      endpoint: 'product/create',
      method: 'POST',
      body: data
    })
    callback(true)
  } catch (err) {
    callback(false, err.message)
  }
}

export const updateProduct = async (data: unknown, callback: (isSuccess: boolean, message?: string) => void): Promise<void> => {
  try {
    await CallApi({
      endpoint: `product/${(data as Record<string, unknown>).id}`,
      method: 'PUT',
      body: data
    })
    callback(true)
  } catch (err) {
    callback(false, err.message)
  }
}